import { motion } from "framer-motion";
import { SectionHeading, EASE } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Analisi & posizionamento",
    desc: "Studiamo il territorio, i competitor e il tuo cliente tipo. Definiamo cosa ti rende diverso — e come farlo pesare.",
  },
  {
    n: "02",
    title: "Storytelling & direzione artistica",
    desc: "Fotografie, testi e palette: raccontiamo l'esperienza del tuo locale, non solo l'elenco dei servizi.",
  },
  {
    n: "03",
    title: "Sviluppo sartoriale & SEO",
    desc: "Design e codice su misura, rapidi su mobile, ottimizzati per Google Maps e le ricerche locali.",
  },
  {
    n: "04",
    title: "Lancio, formazione & supporto",
    desc: "Andiamo online insieme, ti formiamo nella gestione e restiamo al tuo fianco con supporto continuo.",
  },
];

export default function Process() {
  return (
    <section id="metodo" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          tag="Il metodo Nex"
          title={
            <>
              Quattro passi, dal locale di quartiere alla <em className="italic text-terracotta">vetrina di città.</em>
            </>
          }
        />

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${i + 1}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.85, delay: i * 0.09, ease: EASE }}
              className="group relative border-t border-line pt-7 transition-colors duration-500 hover:border-terracotta"
            >
              <span
                className="absolute -top-[5px] left-0 h-[9px] w-[9px] rounded-full bg-faded transition-colors duration-500 group-hover:bg-terracotta"
                aria-hidden="true"
              />
              <p className="font-accent text-sm tracking-[0.3em] text-terracotta">{s.n}</p>
              <h3 className="mt-4 font-serif text-xl leading-snug tracking-tight text-bone">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-stone">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}